<template>
  <div class="container-lg p-0 overflow-hidden">
    <div v-for="comic in comics" :key="comic.slug" class="row item">
      <div :id="comic.slug" class="col text-center">
          <router-link :to="`/comic/${comic.slug}`">
            <h3 class="pt-2 filter">{{ comic.title }}</h3>
            <div class="mb-4 mx-auto banner" :style="`background: url(${comic.thumbnail}) 50% 50% no-repeat;`"></div>
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "Home",
  mounted() {
    if(this.comics.length === 0) this.$store.dispatch('fetchDownloads');
    const div = $(this.$route.hash);  // eslint-disable-line no-undef
    div.length && $('html,body').scrollTop(div.offset().top);  // eslint-disable-line no-undef
  },
  updated() {
  },
  data() {
    return {}
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'comics',
    ])
  }
}
</script>
